export default __webpack_public_path__ + "static/media/job-teaser_ticket-btn.368c9ac6.svg";